import { useNavigate } from 'react-router-dom';
import logo from '@/assets/logo.png';
import { useSelector } from 'react-redux';
import {
  ConfigProvider, Dropdown, Avatar, Button,
} from 'antd';
import { useLanguage } from '@/hooks/use-language';
import { useTranslation } from 'react-i18next';
import styles from './Layout.module.css';

const sliderHeight = '62px';

const UserDropMenu = ({ email }) => {
  const navigate = useNavigate();
  return (
    <Dropdown
      menu={{
        style: { padding: 0 },
        items: [
          {
            key: 1,
            label: (
              <Button className={styles.userDropButton} onClick={() => navigate('../order-list')}>
                My orders
              </Button>
            ),
          },
          {
            key: 2,
            label: (
              <a
                className={styles.userDropLink}
                href="https://kover2618.zendesk.com/hc/en-us/categories/8621004064155-Shoppers"
                rel="noreferrer"
                target="_blank"
              >
                Help center
              </a>
            ),
          },
          {
            key: 3,
            style: { padding: 0 },
            label: (
              <div className={styles.userDropSeparator}>
                <div className={styles.userDropSignOut}>
                  <div className={styles.userDropIcon}>
                    {/* <ArrowRightOutlined /> */}
                    x
                  </div>
                  <div>Sign out</div>
                </div>
              </div>
            ),
            onClick: () => {
              navigate('../login');
            },
          },
        ],
      }}
      placement="bottomRight"
    >
      <Avatar size="default" style={{ backgroundColor: '#645AFF', cursor: 'pointer' }}>
        {email?.[0]?.toLocaleUpperCase()}
      </Avatar>
    </Dropdown>
  );
};

const ReturnHeader = ({
  configLogo = '', handleBack, action, logoUrl = '',
}) => {
  const coBrandingLogo = configLogo || logo;
  const { langSelectCom } = useLanguage();
  const shopDomain = '';
  const email = '';
  // const email = "wumin@seel.com";
  return (
    <>
      <div className={styles.header} style={{ height: sliderHeight }}>
        <div className={styles.headerInner}>
          <div>
            {handleBack && (
              <div className={styles.back} onClick={handleBack}>
                <svg fill="none" height="13" viewBox="0 0 16 13" width="16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 6.5H1" stroke="black" />
                  <path d="M6.5 1L1 6.5L6.5 12" stroke="black" />
                </svg>
                Back
              </div>
            )}
          </div>
          {coBrandingLogo && (logoUrl || shopDomain) ? (
            <a href={logoUrl || `https://${shopDomain}`} rel="noreferrer" target="_blank">
              <img
                alt="Co-branding Logo"
                className={styles.logo}
                src={coBrandingLogo}
                style={{
                  marginLeft: langSelectCom ? '140px' : '0px',
                }}
              />
            </a>
          ) : (
            <img
              alt="Co-branding Logo"
              className={styles.logo}
              src={coBrandingLogo}
              style={{
                marginLeft: langSelectCom ? '140px' : '0px',
              }}
            />
          )}

          <div className={styles.headerRight}>
            {action}
            {langSelectCom}
            <div className={styles.userDropContainer}>
              {email ? <UserDropMenu email={email} /> : null}
              {/* <div className="bg-[#645AFF] text-white w-[30px] h-[30px] leading-[30px] text-center rounded-full">{email[0].toLocaleUpperCase()}</div> */}
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: sliderHeight }}></div>
    </>
  );
};
export const ReturnLayout = ({
  children, handleBack, action, logoUrl = '',
}) => {
  const { t } = useTranslation();
  const loginLayout = useSelector((state) => state?.layoutSetting?.loginLayout); // 获取 loginLayout 状态
  const returnConfig = loginLayout?.isVisible ? loginLayout : {};
  const isLogin = loginLayout?.isVisible;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#000000',
          colorInfo: '#000000',
          wireframe: true,
          colorBgContainerDisabled: '#D9D9D9',
          colorPrimaryBg: '#5c6ac41f',
          colorTextDisabled: '#fff',
          colorPrimaryBgHover: '#000000BF',
          fontFamily: returnConfig?.fontFamily,
          // defaultHoverColor: "#C8C5FF",
        },
      }}
    >
      <div
        className={styles.layoutContainer}
        style={{ backgroundImage: isLogin ? `url(${returnConfig.background})` : '', fontFamily: returnConfig.fontFamily }}
      >
        <ReturnHeader action={action} configLogo={returnConfig.logo} handleBack={handleBack} logoUrl={logoUrl} />
        <div className={styles.contentContainer} style={{ minHeight: `calc(100vh - ${sliderHeight})` }}>
          {/* <Outlet /> */}
          {children}
          {isLogin && !returnConfig.removePoweredBy && (
            <div className={styles.poweredBy}>
              <div className={styles.poweredByInner}>
                {t('Powered by')}
                <img alt="" className={styles.poweredByImage} src="https://resolution.seel.com/static-resource/images/letters-logo.svg" />
              </div>
            </div>
          )}
        </div>
      </div>
    </ConfigProvider>
  );
};
